export default () => ({
  status: {
    error: '',
  },
  cities: [],
});
